import { booleanAttribute, ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { BasicContentComponent } from '../basic-content/basic-content.component';
import { BasicFooterComponent } from '../basic-footer/basic-footer.component';
import { BasicHeaderComponent } from '../basic-header/basic-header.component';

@Component({
  selector: 'la-basic-page',
  templateUrl: './basic-page.component.html',
  styleUrl: './basic-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BasicHeaderComponent, BasicContentComponent, BasicFooterComponent],
})
export class BasicPageComponent {
  @HostBinding('class.internal') @Input({ transform: booleanAttribute }) internal = false;

  @HostBinding('style.--la-container-bg') get containerBackground(): string {
    return this.internal ? 'var(--mat-sys-secondary)' : '#1e3f31';
  }
}
